// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─────────────────────────────────────────────────────────────
   ConfirmDialog · destructive confirmation built on the Modal
   primitive. Type-to-confirm input uses mono + danger focus ring.
   ───────────────────────────────────────────────────────────── */

.confirm-body {
  font-size: var(--fs-detail);
  line-height: 1.55;
  color: var(--text-secondary);
}
[data-theme='dark'] .confirm-body {
  color: var(--ink-text-2);
}

/* Lead corto del confirm (una línea), antes del resumen estructurado. */
.confirm-lead {
  margin: 0;
  font-size: var(--fs-ui);
  line-height: 1.5;
  color: var(--text-secondary);
}

/* Resumen estructurado (dl) — filas label/valor: label mono en mayúsculas,
   valor legible. Reemplaza la prosa por información ordenada de lo que se va
   a hacer. */
.confirm-summary {
  margin: 14px 0 0;
  border-top: 1px solid var(--border);
}
.confirm-summary__row {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 12px;
  align-items: baseline;
  padding: 9px 0;
  border-bottom: 1px solid var(--border-soft);
}
.confirm-summary__row dt {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--text-muted);
}
.confirm-summary__row dd {
  margin: 0;
  font-size: var(--fs-detail);
  color: var(--text);
}

.confirm-type {
  display: block;
  margin-top: 16px;
}
.confirm-type__lbl {
  display: block;
  font-size: var(--fs-meta);
  color: var(--text-muted);
  margin-bottom: 6px;
}
.confirm-type__lbl b {
  font-family: var(--mono);
  font-weight: 500;
  color: var(--danger);
  letter-spacing: 0.04em;
}
[data-theme='dark'] .confirm-type__lbl b {
  color: #f2887e;
}

.confirm-type__input {
  width: 100%;
  height: 36px;
  padding: 0 12px;
  font-family: var(--mono);
  font-size: var(--fs-ui);
  letter-spacing: 0.04em;
  color: var(--text);
  background: var(--bg);
  border: 1px solid var(--border);
  border-radius: var(--r-data);
  outline: none;
  transition:
    border-color 0.1s,
    box-shadow 0.1s;
}
.confirm-type__input:focus {
  border-color: var(--danger);
  box-shadow: var(--focus-ring-err);
}
[data-theme='dark'] .confirm-type__input {
  background: var(--ink-dark);
  color: var(--ink-text);
  border-color: var(--ink-rule);
}
[data-theme='dark'] .confirm-type__input:focus {
  border-color: #f2887e;
  box-shadow: 0 0 0 3px rgba(180, 35, 24, 0.22);
}
`, "",{"version":3,"sources":["webpack://./src/ui/ConfirmDialog/ConfirmDialog.css"],"names":[],"mappings":"AAAA;;;kEAGkE;;AAElE;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,wBAAwB;AAC1B;;AAEA,wEAAwE;AACxE;EACE,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;aAEa;AACb;EACE,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,qBAAqB;EACrB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb;;mBAEiB;AACnB;AACA;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;AACA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C","sourcesContent":["/* ─────────────────────────────────────────────────────────────\n   ConfirmDialog · destructive confirmation built on the Modal\n   primitive. Type-to-confirm input uses mono + danger focus ring.\n   ───────────────────────────────────────────────────────────── */\n\n.confirm-body {\n  font-size: var(--fs-detail);\n  line-height: 1.55;\n  color: var(--text-secondary);\n}\n[data-theme='dark'] .confirm-body {\n  color: var(--ink-text-2);\n}\n\n/* Lead corto del confirm (una línea), antes del resumen estructurado. */\n.confirm-lead {\n  margin: 0;\n  font-size: var(--fs-ui);\n  line-height: 1.5;\n  color: var(--text-secondary);\n}\n\n/* Resumen estructurado (dl) — filas label/valor: label mono en mayúsculas,\n   valor legible. Reemplaza la prosa por información ordenada de lo que se va\n   a hacer. */\n.confirm-summary {\n  margin: 14px 0 0;\n  border-top: 1px solid var(--border);\n}\n.confirm-summary__row {\n  display: grid;\n  grid-template-columns: 120px 1fr;\n  gap: 12px;\n  align-items: baseline;\n  padding: 9px 0;\n  border-bottom: 1px solid var(--border-soft);\n}\n.confirm-summary__row dt {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n.confirm-summary__row dd {\n  margin: 0;\n  font-size: var(--fs-detail);\n  color: var(--text);\n}\n\n.confirm-type {\n  display: block;\n  margin-top: 16px;\n}\n.confirm-type__lbl {\n  display: block;\n  font-size: var(--fs-meta);\n  color: var(--text-muted);\n  margin-bottom: 6px;\n}\n.confirm-type__lbl b {\n  font-family: var(--mono);\n  font-weight: 500;\n  color: var(--danger);\n  letter-spacing: 0.04em;\n}\n[data-theme='dark'] .confirm-type__lbl b {\n  color: #f2887e;\n}\n\n.confirm-type__input {\n  width: 100%;\n  height: 36px;\n  padding: 0 12px;\n  font-family: var(--mono);\n  font-size: var(--fs-ui);\n  letter-spacing: 0.04em;\n  color: var(--text);\n  background: var(--bg);\n  border: 1px solid var(--border);\n  border-radius: var(--r-data);\n  outline: none;\n  transition:\n    border-color 0.1s,\n    box-shadow 0.1s;\n}\n.confirm-type__input:focus {\n  border-color: var(--danger);\n  box-shadow: var(--focus-ring-err);\n}\n[data-theme='dark'] .confirm-type__input {\n  background: var(--ink-dark);\n  color: var(--ink-text);\n  border-color: var(--ink-rule);\n}\n[data-theme='dark'] .confirm-type__input:focus {\n  border-color: #f2887e;\n  box-shadow: 0 0 0 3px rgba(180, 35, 24, 0.22);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
